import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { PropsWithClassname } from '@/app/types';

export enum NotificationType {
  DISABLED = 'disabled',
  SUCCESS = 'success',
  WARNING = 'warning',
}

interface NotificationProps extends PropsWithClassname {
  type?: NotificationType;
  children: ReactNode;
}

const Notification = ({ type = NotificationType.DISABLED, children, className }: NotificationProps) => {
  return (
    <p
      className={classNames(className, 'block w-full rounded-[4px] p-[16px] shadow-md', {
        'bg-neutral-light text-neutral-semiTransparent': type === NotificationType.DISABLED,
        'bg-success-light text-success-mid border border-success-midLight': type === NotificationType.SUCCESS,
        'bg-alert': type === NotificationType.WARNING,
      })}
    >
      {children}
    </p>
  );
};

export default Notification;
